<template>
  <div>
    <company-add></company-add>
  </div>
</template>

<script>
import CompanyAdd from "./CompanyAdd.vue";

export default {
  components: {
    CompanyAdd,
  },

  data() {
    return {};
  },
};
</script>
